module.exports = __webpack_public_path__ + "img/vmware-digitalfoundation.b4928e89.jpg";